import { KYMW6501Component } from './kymw6501.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { TimeSaleDataModel } from './vo/time-sale-data.model';

/**
 * ECタイムセールマスタ設定画面の値を管理するクラス
 *
 * @export KYMW6501Model
 * @class KYMW6501Model
 */
export class KYMW6501Model {

  kymw6501Component: KYMW6501Component;

  public startHourList = [];

  public startMinuteList = [];

  public endHourList = [];

  public endMinuteList = [];

  public startDate: Date = new Date;
  // 編集有無フラグ
  public isEdited: boolean = <boolean>false;
  // 処理区分
  public procesDiv: string = TimeSaleDataModel.PROCES_DIV_REGIST;
  // 確認フラグ
  public confirmFlg: string = <string>'0';
  // 更新日時
  public updateDate: string = <string>'';

  public categoryCode: string = <string>'';
  public orderCode: string = <string>'';
  public startDateYMD: string = <string>'';
  public startDateHH: string = <string>'00';
  public startDateMI: string = <string>'00';
  public endDateYMD: string = <string>'';
  public endDateHH: string = <string>'00';
  public endDateMI: string = <string>'00';
  public bannerFileNameBfBB: string = <string>'';
  public bannerCaptionBfBB: string = <string>'';
  public bannerFileNameOnBB: string = <string>'';
  public bannerCaptionOnBB: string = <string>'';
  public bannerFileNameAfBB: string = <string>'';
  public bannerCaptionAfBB: string = <string>'';
  public bannerFileNameBfMB: string = <string>'';
  public bannerCaptionBfMB: string = <string>'';
  public bannerFileNameOnMB: string = <string>'';
  public bannerCaptionOnMB: string = <string>'';
  public bannerFileNameAfMB: string = <string>'';
  public bannerCaptionAfMB: string = <string>'';
  public bannerFileNameBfSP: string = <string>'';
  public bannerCaptionBfSP: string = <string>'';
  public bannerFileNameOnSP: string = <string>'';
  public bannerCaptionOnSP: string = <string>'';
  public bannerFileNameAfSP: string = <string>'';
  public bannerCaptionAfSP: string = <string>'';

  /**
   * 初期表示
   *
   * @param {*} serverData
   * @memberof KYMW6501Model
   */
  public setInitData(serverData: any): void {
    // 初期表示
    this.categoryCode = serverData.CategoryCode;
    this.orderCode = serverData.OrderCode;
    this.startDateYMD = String(serverData.StartDate).substr(0, 10);
    this.startDateHH = String(serverData.StartDate).substr(11, 2);
    this.startDateMI = String(serverData.StartDate).substr(14, 2);
    this.endDateYMD = String(serverData.EndDate).substr(0, 10);
    this.endDateHH = String(serverData.EndDate).substr(11, 2);
    this.endDateMI = String(serverData.EndDate).substr(14, 2);
    this.bannerFileNameBfBB = serverData.BannerFileNameBfBb;
    this.bannerCaptionBfBB = serverData.BannerCaptionBfBb;
    this.bannerFileNameOnBB = serverData.BannerFileNameOnBb;
    this.bannerCaptionOnBB = serverData.BannerCaptionOnBb;
    this.bannerFileNameAfBB = serverData.BannerFileNameAfBb;
    this.bannerCaptionAfBB = serverData.BannerCaptionAfBb;
    this.bannerFileNameBfMB = serverData.BannerFileNameBfMb;
    this.bannerCaptionBfMB = serverData.BannerCaptionBfMb;
    this.bannerFileNameOnMB = serverData.BannerFileNameOnMb;
    this.bannerCaptionOnMB = serverData.BannerCaptionOnMb;
    this.bannerFileNameAfMB = serverData.BannerFileNameAfMb;
    this.bannerCaptionAfMB = serverData.BannerCaptionAfMb;
    this.bannerFileNameBfSP = serverData.BannerFileNameBfSp;
    this.bannerCaptionBfSP = serverData.BannerCaptionBfSp;
    this.bannerFileNameOnSP = serverData.BannerFileNameOnSp;
    this.bannerCaptionOnSP = serverData.BannerCaptionOnSp;
    this.bannerFileNameAfSP = serverData.BannerFileNameAfSp;
    this.bannerCaptionAfSP = serverData.BannerCaptionAfSp;
    this.updateDate = serverData.UpdateDate;

    // デフォルトフォーカスの設定
    this.kymw6501Component.initFocus();

    this.isEdited = false;
  }

  /**
   * タイムセールマスタ情報VO取得
   *
   * @returns {*}
   * @memberof KYMW6501Model
   */
  public getTimeSaleDataVo(): any {
    const vo: TimeSaleDataModel = new TimeSaleDataModel();                      // タイムセールマスタ情報VO

    vo.OrderCode = this.orderCode;
    vo.CategoryCode = this.categoryCode;
    if (this.startDateYMD) {
      vo.StartDateYMD = this.startDateYMD;
    } else {
      vo.StartDateYMD = '';
    }
    vo.StartDateHH = this.startDateHH;
    vo.StartDateMI = this.startDateMI;
    if (this.endDateYMD) {
      vo.EndDateYMD = this.endDateYMD;
    } else {
      vo.EndDateYMD = '';
    }
    vo.EndDateHH = this.endDateHH;
    vo.EndDateMI = this.endDateMI;
    vo.BannerFileNameBfBB = this.bannerFileNameBfBB;
    vo.BannerCaptionBfBB = this.bannerCaptionBfBB;
    vo.BannerFileNameOnBB = this.bannerFileNameOnBB;
    vo.BannerCaptionOnBB = this.bannerCaptionOnBB;
    vo.BannerFileNameAfBB = this.bannerFileNameAfBB;
    vo.BannerCaptionAfBB = this.bannerCaptionAfBB;
    vo.BannerFileNameBfMB = this.bannerFileNameBfMB;
    vo.BannerCaptionBfMB = this.bannerCaptionBfMB;
    vo.BannerFileNameOnMB = this.bannerFileNameOnMB;
    vo.BannerCaptionOnMB = this.bannerCaptionOnMB;
    vo.BannerFileNameAfMB = this.bannerFileNameAfMB;
    vo.BannerCaptionAfMB = this.bannerCaptionAfMB;

    vo.BannerFileNameBfSP = this.bannerFileNameBfSP;
    vo.BannerCaptionBfSP = this.bannerCaptionBfSP;
    vo.BannerFileNameOnSP = this.bannerFileNameOnSP;
    vo.BannerCaptionOnSP = this.bannerCaptionOnSP;
    vo.BannerFileNameAfSP = this.bannerFileNameAfSP;
    vo.BannerCaptionAfSP = this.bannerCaptionAfSP;

    vo.UpdateDate = PlessViewUtilsSub.nullToBlank(this.updateDate);
    vo.ConfirmFlg = this.confirmFlg;

    return vo;
  }

}
